"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var currencies_1 = require("../config/currencies");

var site_1 = require("../config/site");
/**
 * @param { Number }
 * devuelve un valor numerico con el formato correspondiente al pais donde estemos
 */


exports.numberTropicalizer = function (number) {
  return typeof number === 'number' && number.toString().replace('.', currencies_1.Currencies[site_1.siteId].decimalSeparatorSymbol).replace(/\B(?=(\d{3})+(?!\d))/g, currencies_1.Currencies[site_1.siteId].thousandsSeparatorSymbol);
};